<!--
 * @Author: 彭梦婷
 * @Date: 2026-08-10 10:56:14
 * @LastEditors: 彭梦婷
 * @LastEditTime: 2026-08-14 17:28:20
 * @Description: 
 * @FilePath: \company-web\src\App.vue
-->
<template>
  <div id="app">
    <!-- v-if="isDataReady" -->
    <router-view />

  </div>
</template>

<script>
export default {
    data() {
    return {
      isDataReady: false
    }
  },
  async created() {
    await this.$store.dispatch('fetchCustomerInfo')
    this.isDataReady = true
  }
}
</script>

<style lang="scss">
@import '@/assets/styles/common.scss';

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
